import LegalPage from "@/components/LegalPage";
import { LEGAL_LAST_UPDATED } from "@/data/legal";

const sections = [
  { h: "General information only", p: "Content on this website is provided for general information and does not constitute clinical, dental, medical or legal advice. Please consult a qualified professional for advice specific to your circumstances." },
  { h: "No dentist-patient relationship", p: "Using this website does not create a dentist-patient relationship between you and School Smiles Australia." },
  { h: "Third-party information", p: "Information from third parties, including Medicare and the Child Dental Benefits Schedule, is subject to change. Please confirm current details directly with the relevant authority." },
  { h: "Emergency care", p: "This website is not intended for dental emergencies. If you are experiencing a dental emergency, please contact your regular dentist or, in serious cases, call emergency services." },
];

const Disclaimer = () => {
  if (typeof document !== "undefined") document.title = "Website Disclaimer — School Smiles Australia";
  return <LegalPage title="Website Disclaimer" kicker="Legal" sections={sections} lastUpdated={LEGAL_LAST_UPDATED}/>;
};

export default Disclaimer;
